// extracted by mini-css-extract-plugin
export default {"main":"Portfolio_main__IHsK9","box":"Portfolio_box__6NZ5B","title":"Portfolio_title__V9WeO","list":"Portfolio_list__k1IfK","button":"Portfolio_button__Pg6Uy"};